<template>
  <div>
     <div v-if="user">
      <v-btn v-if="isFavorite(product.id)" absolute depressed class="white red--text" rounded bottom right @click.stop="removeFromFavorites(product.id)">
        <v-tooltip bottom color="gray darken-3">
          <template v-slot:activator="{ on }">
            <v-icon color="red" dark v-on="on">favorite</v-icon>
          </template>
          <span class="font-weight-medium">Remove product from favorites</span>
        </v-tooltip>
      </v-btn>
      <v-btn v-else absolute depressed class="white red--text" rounded bottom right @click.stop="addToFavorites(product)">
        <v-tooltip bottom color="gray darken-3">
          <template v-slot:activator="{ on }">
            <v-icon color="red" dark v-on="on">favorite_border</v-icon>
          </template>
          <span class="font-weight-medium">Add product to favorites</span>
        </v-tooltip>
      </v-btn>
    </div>
    <div v-else>
      <NotAuthFavoriteDialog />
    </div>
    <v-snackbar v-model="snackbar" color="primary white--text" :timeout="time" bottom right>
      {{ snackbarText }}
      <template>
        <v-btn color="white" text @click.stop.prevent="addBackToFavorites(product)">
          UNDO
        </v-btn>
        <v-icon color="white" @click.stop.prevent="confirmRemoval(product.id)">close</v-icon>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'
export default {
  name: 'FavoriteBtn',
  props: ['product'],
  components: {
    NotAuthFavoriteDialog: () => import('@/components/product/NotAuthFavoriteDialog')
  },
  data() {
    return {
      snackbar: false,
      time: 7000,
      snackbarText: 'Removed one product from the favorites'
    }
  },
  computed: {
    ...mapGetters(['user', 'favoriteProductsIds']),
    isFavorite() {
      return id => this.favoriteProductsIds.includes(id)
    }
  },
  methods: {
    addToFavorites(product) {
      store.dispatch('addToFavorites', product)
    },
    removeFromFavorites(id) {
      this.snackbar = true
      // only remove it from the vue store
      store.dispatch('removeFromFavorites_store', id)

      // after timeout remove it from firebase too
      this.timeout = setTimeout(() => {
        store.dispatch('removeFromFavorites', id)
      }, this.time)
    },
    addBackToFavorites(product) {
      this.snackbar = false

      store.dispatch('addBackToFavorites', product)
      // clear the timeout
      clearTimeout(this.timeout)
    },

    confirmRemoval(id) {
      this.snackbar = false
      // remove from firestore
      store.dispatch('removeFromFavorites', id)
      // clear the timeout
      clearTimeout(this.timeout)
    }
  }
}
</script>
